const WHITELIST_USERS = [
  'cdn-guest@mailinator.com',
  'cdn-admin@arts.nsw.gov.au',
  'cdn-admin@britishcouncil.org',
  'taksobuild1@yopmail.com',
  'taksobuild2@yopmail.com',
];

export default WHITELIST_USERS;
